module.exports = __webpack_public_path__ + "img/zeladoria.b349ef43.jpg";